module.exports = __webpack_public_path__ + "img/lg_ring_y_e_null_null@3x.04be07ea.png";